<template>
    <div class="head-db">
      <div class="top">
        <img :src="slide.image" alt="">
      </div>
      <div class="topnav">
        <div class="w1200">
          <ul class="navul">
            <li :class="curNav!=null && curNav.id==item.id?'navitem cur':'navitem'" v-for="item in navList">
              <a :href="item.web_url!=''?item.web_url:'javascript:void(0)'">{{item.name}}</a>
              <ul class="smul" v-if="item.subList !== null">
                <li v-for="subItem in item.subList">
                  <a :href="subItem.web_url">{{subItem.name}}</a>
                </li>
              </ul>
            </li>
            <!--<li class="navitem">-->
              <!--<a href="/about">血站概况</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/list">新闻动态</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/list">信息公开</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/bloodsearch">献血服务</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/list">党建与文明</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/list">血液科普</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/list">热血风采</a>-->
            <!--</li>-->
            <!--<li class="navitem">-->
              <!--<a href="/interact">互动交流</a>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'tHead',
        data() {
            return {
                slide: [],
                navList: [],
                curNav: null
            }
        },
        mounted: function () {
            this.getSlideList();
            this.initData();
        },
        methods: {
            getSlideList: async function() {
                let res = await this.$getJSON('index/getSlideList',{cat_id:1});
                if (res.code == 1) {
                    let slideList= res.data.slideList;
                    this.slide = slideList[0];
                }
            },
            initData: async function () {
                let url = window.location.pathname + window.location.search;
                let res = await this.$getJSON('nav/index',{url:url});
                if (res.code == 1) {
                  this.navList = res.data.navList;
                  this.curNav = res.data.curNav;
                }
            },
            getURL(url){
                //如果为真则为外链
                let strURL = false;
                if(url.substr(0,7).toLowerCase() == "http://" || url.substr(0,8).toLowerCase() == "https://"){
                  strURL = true;
                }else{
                  strURL = false;
                }
                return strURL;
            },
        }
    }
</script>

<style lang="scss">
  .head-db{
   .top{
     img{
       width: 100%;
     }
   }
    .topnav{
      width: 100%;
      height: 70px;
      background: linear-gradient(0deg, #ff2464,#ff729e);
      .navul{

        .navitem{
          float: left;
          width: 133px;
          line-height: 70px;
          text-align: center;
          font-size: 18px;
          background-image: url("../../images/zxxz/line.png") ;
          background-position: center right;
          background-repeat: no-repeat;
          background-size: 1px;
          position: relative;

          a{
            color: #fff;
          }
          &:last-child{
            background: none;
          }
          &.cur{

            background-color:#f42363 ;
          }
          &:hover{
            background-color:#f42363 ;
            .smul{
              display: block;
            }
          }
          .smul{
            position: absolute;
            width: 100%;
            top: 100%;
            left: 0;
            display: none;
            z-index: 99999999999;
            li{
              background: #f42363;
              line-height: 50px;
              a{
                font-size: 16px;
              }
              &:hover{
                background: #f42363;
              }
            }
          }
        }
      }
    }
    .code{
      position: fixed;
      top: 285px;
      right: 2%;
      z-index: 99999999999999999999;
      li{
        background: #fff;
        margin-bottom: 8px;
        text-align: center;
        padding: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/head.vue